import classNames from 'classnames';
import * as BrandDefinition from 'modules/BrandDefinition';
import { getBrandFontRefFromBrandStyle } from 'modules/BrandDefinition/utils';
import React from 'react';
import { BrandStyleProp } from 'models';
import { getDesktopBrandStyles } from 'utils/brandStyles';
import { getFontColorFromBrandStyle } from 'utils/brandStyles/getColorTypeFromBrandStyle';
import { StyleProps } from './models';
import styles from './styles.module.scss';

const Style: React.FunctionComponent<StyleProps> = (props) => {
  const { active, style, toggleBrandStyle, colors, fonts, dataTestId = 'style' } = props;
  const brandStyleName = style.get('name');
  const desktopStyles = getDesktopBrandStyles(style);
  const fontSize = desktopStyles?.get(BrandStyleProp.FONT_SIZE);
  const fontColor = getFontColorFromBrandStyle(
    desktopStyles?.get(BrandStyleProp.COLOR),
    colors,
    desktopStyles,
    fonts,
  );
  const { fontName, characterStyleName } = getBrandFontRefFromBrandStyle(desktopStyles, fonts) ?? {};
  const brandFont = fonts.find(font => font?.get('name') === fontName);
  let fontFaceToShow = '';
  let updatedFontFamily;
  let fontStyle;
  let fontWeight;

  if (brandFont) {
    const fontFamily = brandFont.get('name');
    const brandCharStyles = brandFont.get('characterStyles');
    const brandCharStyle = brandCharStyles?.find(charStyle => charStyle?.get('name') === characterStyleName);
    const brandCharStyleName = brandCharStyle?.get('name');
    if (fontFamily && brandCharStyleName) {
      updatedFontFamily = BrandDefinition.getBrandFontValueFontFamily(
        fonts,
        { fontName: fontFamily, characterStyleName: brandCharStyleName },
      );
    }
    fontStyle = brandCharStyle ? brandCharStyle.get('fontStyle') : '';
    fontWeight = brandCharStyle ? Number(brandCharStyle.get('fontWeight')) : '';
    let charStyleToShow = '';
    if (brandCharStyle) {
      charStyleToShow = ` ${brandCharStyle.get('name')}`;
    }
    fontFaceToShow = `${brandFont.get('name')}${charStyleToShow}`;
  }

  const handleClick = (): void => {
    toggleBrandStyle(style);
  };

  return (
    <div
      className={classNames(styles.Style, {
        [styles.active]: active,
      })}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      <div className={styles.Description} data-testid={`${dataTestId}-description`}>
        {fontColor && (
          <div className={styles.Color} style={{ backgroundColor: fontColor }} data-testid={`${dataTestId}-color`} />
        )}
        <div
          className={styles.Name}
          style={{ fontSize, fontFamily: updatedFontFamily, fontStyle, fontWeight }}
          data-testid={`${dataTestId}-name`}
        >
          {brandStyleName}
        </div>
      </div>
      <div className={styles.Details} data-testid={`${dataTestId}-details`}>
        {fontFaceToShow && `${fontFaceToShow} - `}
        {fontSize}
      </div>
    </div>
  );
};

export default Style;
